document.addEventListener('DOMContentLoaded', function () {
    
    // Hero Slider
    const heroSwiper = new Swiper('.heroSwiper', {
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
          return `
            <span class="${className}">
              <svg class="progress-svg" width="14" height="14">
                <circle class="bg" cx="7" cy="7" r="5"></circle>
                <circle class="progress" cx="7" cy="7" r="5"></circle>
              </svg>
            </span>
          `;
            },
        },
    });

    // Product Slider
    const productSwiper = new Swiper('.productSwiper', {
        slidesPerView: 3.7,
        spaceBetween: 25,
        loop: true,
        navigation: {
            nextEl: '.product-next',
            prevEl: '.product-prev',
        },
        breakpoints: {
            320: { slidesPerView: 1.2, spaceBetween: 15 },
            768: { slidesPerView: 2.8, spaceBetween: 20 },
            1025: { slidesPerView: 3, spaceBetween: 25 },
            1600: { slidesPerView: 3, spaceBetween: 25 }
        }
    });

});


document.addEventListener("DOMContentLoaded", function () {

  const openPopupBtn = document.getElementById("popup-newsletter-open-btn");
  const popup = document.getElementById("popup-newsletter");
  const closePopupBtn = document.getElementById("popup-newsletter-close-btn");
  const closePopupText = document.querySelector('.close-btn-text');

  // Open popup
  if (openPopupBtn && popup) {
    openPopupBtn.addEventListener("click", function () {
      popup.style.display = "flex";
      popup.style.animation = "none";

      setTimeout(() => {
        popup.style.animation = "fadeIn 0.5s forwards";
      }, 10);
    });
  }

  // Close popup (button)
  if (closePopupBtn && popup) {
    closePopupBtn.addEventListener("click", function () {
      popup.style.display = "none";
    });
    closePopupText.addEventListener('click', () =>{
      popup.style.display = "none";
    })
  }

  // Close popup (outside click)
  if (popup) {
    window.addEventListener("click", function (event) {
      if (event.target === popup) {
        popup.style.display = "none";
      }
    });
  }

});


document.addEventListener("DOMContentLoaded", function () {
    function faqsAccordion() {
        var accordionSections = document.querySelectorAll(".accordion-item");

        if (accordionSections.length > 0) {
            var firstAccordionItemHeader = accordionSections[0].querySelector(
                ".accordion-item-header"
            );
            var firstAccordionItemBody =
                firstAccordionItemHeader.nextElementSibling;

            if (firstAccordionItemBody) {
                firstAccordionItemHeader.classList.add("active");
                firstAccordionItemBody.style.maxHeight =
                    firstAccordionItemBody.scrollHeight + "px";
            }

            for (let i = 1; i < accordionSections.length; i++) {
                var otherHeader = accordionSections[i].querySelector(
                    ".accordion-item-header"
                );
                var otherBody = otherHeader.nextElementSibling;

                if (otherBody) {
                    otherHeader.classList.remove("active");
                    otherBody.style.maxHeight = "0";
                }
            }
        }

        accordionSections.forEach((section) => {
            var accordionItemHeaders = section.querySelector(
                ".accordion-item-header"
            );
            var accordionItemBody = section.querySelector(".accordion-item-body");

            accordionItemHeaders.addEventListener("click", function () {
                var currentlyActiveHeader = document.querySelector(
                    ".accordion-item-header.active"
                );
                var currentlyActiveBody = currentlyActiveHeader
                    ? currentlyActiveHeader.nextElementSibling
                    : null;

                if (currentlyActiveHeader && currentlyActiveBody) {
                    currentlyActiveHeader.classList.remove("active");
                    currentlyActiveBody.style.maxHeight = 0;
                }

                if (accordionItemHeaders !== currentlyActiveHeader) {
                    accordionItemHeaders.classList.add("active");
                    accordionItemBody.style.maxHeight =
                        accordionItemBody.scrollHeight + "px";
                } else {
                    accordionItemHeaders.classList.remove("active");
                    accordionItemBody.style.maxHeight = 0;
                }
            });
        });
    }

    faqsAccordion();
});